import React, { useState } from 'react';
import StatusBadge from '../../shared/StatusBadge';
import ActionsMenu from '../shared/components/ActionsMenu';
import PreviewModal from './PreviewModal';
import { changeStatus, copyWithToast, embedCode, landingPageUrl } from './membershipProductActions';
import '../TeamManager/styles/teamManagerStyles.css';

const STATUS_LABELS = { active: 'Published', draft: 'Draft', archived: 'Archived' };

const MembershipProductActionsBar = ({
  membershipProduct,
  team,
  csrfToken,
  onProductUpdate,
  trailing,
}) => {
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false);
  const [isStatusChanging, setIsStatusChanging] = useState(false);

  const status = membershipProduct.status;

  const handleStatusAction = async (action) => {
    setIsStatusChanging(true);
    const updated = await changeStatus({ teamId: team.id, product: membershipProduct, csrfToken, action });
    if (updated && onProductUpdate) onProductUpdate(updated);
    setIsStatusChanging(false);
    setShowArchiveConfirm(false);
  };

  const actions = [
    status !== 'archived' && (
      status === 'draft'
        ? { label: 'Publish Membership', icon: 'fal fa-globe', onClick: () => handleStatusAction('publish'), disabled: isStatusChanging }
        : { label: 'Unpublish Membership', icon: 'fal fa-eye-slash', onClick: () => handleStatusAction('unpublish'), disabled: isStatusChanging }
    ),
    { label: 'Copy Embed Code', icon: 'fal fa-code', onClick: () => copyWithToast(embedCode(team.id, membershipProduct), 'Embed code') },
    { label: 'Copy Landing Page Link', icon: 'fal fa-link', onClick: () => copyWithToast(landingPageUrl(team.id, membershipProduct), 'Landing page link') },
    status !== 'archived' && { label: 'Archive Membership', icon: 'fal fa-archive', onClick: () => setShowArchiveConfirm(true), danger: true, disabled: isStatusChanging },
  ].filter(Boolean);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
        <StatusBadge status={status} label={STATUS_LABELS[status] || status} />
        <ActionsMenu actions={actions} alignLeft buttonClassNames={['team-actions-btn-square']} />
        <button
          type="button"
          className="team-btn-secondary"
          onClick={() => setShowPreviewModal(true)}
        >
          Preview
        </button>
        {membershipProduct.active_members_segment_id && (
          <a
            href={`/teams/${team.id}/segments/${membershipProduct.active_members_segment_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="team-btn-secondary"
          >
            Active Members
          </a>
        )}
        {trailing}
      </div>

      {showPreviewModal && (
        <PreviewModal
          teamId={team.id}
          membershipProduct={membershipProduct}
          onClose={() => setShowPreviewModal(false)}
        />
      )}

      {showArchiveConfirm && (
        <div className="team-modal-overlay">
          <div className="team-modal" style={{ textAlign: 'left', border: 'none', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)', maxWidth: '420px', width: '90%', padding: '0' }}>
            <div className="team-modal-header">
              <h3 className="team-modal-title">Archive membership?</h3>
              <button className="team-modal-close" onClick={() => setShowArchiveConfirm(false)}>
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div className="team-modal-body">
              <p style={{ marginBottom: '8px' }}>
                Archive <strong>{membershipProduct.name}</strong>?
              </p>
              <p>Archived memberships will be removed from display.</p>
            </div>
            <div className="team-modal-footer">
              <button className="team-btn-secondary" onClick={() => setShowArchiveConfirm(false)}>
                Cancel
              </button>
              <button
                className="team-btn-danger"
                onClick={() => handleStatusAction('archive')}
                disabled={isStatusChanging}
              >
                Archive
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MembershipProductActionsBar;
